export const VALIDATE_KEY_VALUES = {
  fullscreen: true,
  loaderText: true
};

export const DEFAULT_VALUES = {
  fullscreen: true,
  id: "kwikui-loader",
  loaderText: "Please wait"
};
